import { render, staticRenderFns } from "./SkupDodatniSadrzajCreate.vue?vue&type=template&id=3938c23e&scoped=true&"
import script from "./SkupDodatniSadrzajCreate.vue?vue&type=script&lang=js&"
export * from "./SkupDodatniSadrzajCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938c23e",
  null
  
)

export default component.exports